import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

const CreateCardDetailContext = createContext();

export const CreateCardDetailProvider = ({ children }) => {
  const apiKey = process.env.REACT_APP_API_KEY; // actual API key
  const objectId = localStorage.getItem("objectId");
  const headers = {
    'x-api-key': apiKey,
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${objectId}`
  };
  axios.defaults.baseURL = `${process.env.REACT_APP_BACKEND_URL}`;
  const [logo, setLogo] = useState(null);


  // Check if objectId is not null and not an empty string after trimming
  if (objectId !== null && objectId.trim() !== "") {
    // console.log("objectId is present:", objectId);
  } else {
    // If objectId is not present or is an empty string after trimming
    console.log("objectId is not present or is empty.");
  }

  const [isPersonalDetailsSaved, setIsPersonalDetailsSaved] = useState(false);
  const [cardDetails, setCardDetails] = useState({
    User_ID: objectId,
    CardType: '',
    CardName: '',
    employee_id: '',
    company_id: '',
    profession_department: '',
    profession_id: '',
    company_website: '',
    is_professional_verified: false,
    professional_details_status: '',
    student_id: '',
    student_email_id: '',
    student_year: '',
    student_ending_year: '',
    student_currently_pursuing: false,
    education_level: '',
    institute: '',
    board: '',
    degree: '',
    field_of_study: '',
    grade: '',
    institute_website: '',
    university_website: '',
    is_student_verified: false,
    student_details_status: '',
    prefix: '',
    suffix: '',
    title: '',
    nickname: '',
    summary: '',
    designation: '',
    company: '',
    profession_department: '',
    professional_email_id: '',
    profile_pic: '',
    logo: '',
    additionalFields: {},
    role_title: '',
    details: '',
    is_experience_current: false,
    employee_type: '',
    location_type: '',
    location: '',
    responsibility: [],
    profile_headline: '',
    start_year: '',
    end_year: '',
    start_month: '',
    end_month: '',
    experience_id: '',
    education_id: ''

  });

  const [CardStyles, setCardStyles] = useState({
    User_ID: objectId,
    CardType: 'Professional',
    CardName: '',
    font: '',
    size: '',
    style: '',
    colorPrimary: '',
    colorSecondary: '',
    colorTitle: '',
    colorLayout: '#0044c6',
    bgColor: '#ffffff',
    imageExtract: null,
    layoutStyle: '1'
  })

  const [CardQrStyles, setCardQrStyles] = useState({
    User_ID: objectId,
    CardType: 'Professional',
    CardName: '',
    eyeBall: '',
    eyeBallcolor: '',
    eyeFrame: '',
    eyeFrameColor: '',
    qrPattern: '',
    qrPatterncolor: '#121212',
    border: '',
    bordercolor: '',
    addbg: '',
    addbgcolor: '#ede8e8'
  })

  const [ContactStyles, setContactStyles] = useState({
    card_type: '',
    CardName: '',
    reference_id: objectId,
    location: '',
    mobile_number: '',
    call_visible: true,
    sms_visible: true,
    email: '',
    email_visible: true,
    whatsapp: '',
    whatsapp_visible: true,
    address: '',
    state: '',
    postal_code: '',
    city: '',
    country: '',
    is_public: true,
  })

  const [SocialLinks, setSocialLinks] = useState({
    user_ref_id: "",
    card_type: 'Professional',
    CardName: '',
    links: [
      { network: 'linkedin', url: '', visible: true },
      { network: 'facebook', url: '', visible: true },
      { network: 'instagram', url: '', visible: true },
    ],
  })

  const [AttachDocs, setAttachDocs] = useState({
    user_ref_id: "",
    card_id: null,
    card_name: "",
    images: [],
    videos: [],
    others: []
  });

  const updateAttachDocsVal = ({ fieldName, value }) => {
    setAttachDocs(prevState => ({
      ...prevState,
      [fieldName]: value
    }));
  };


  const updateCardDetails = (updatedDetails) => {

    setCardDetails((prevDetails) => ({
      ...prevDetails,
      ...updatedDetails,
    }));
  };

  const updateCardStyles = (updatedCardStyles) => {
    setCardStyles((prevStyles) => (
      {
        ...prevStyles,
        ...updatedCardStyles,
      }
    ))
  }

  const updateCardQrStyles = (updatedCardQrStyles) => {
    // { console.log("Updated Qr Styles in Card Details", updatedCardQrStyles) }
    setCardQrStyles((prevqrStyles) => (
      {
        ...prevqrStyles,
        ...updatedCardQrStyles,
      }
    ))
  }


  const updateContactStyles = (updatedContactStyles) => {
    setContactStyles((prevContactStyles) => (
      {
        ...prevContactStyles,
        ...updatedContactStyles,
      }
    ))
  }
  const updateSocialLinks2 = (updateddata) => {
    setSocialLinks((prevSocialLinks) => (
      {
        ...prevSocialLinks,
        ...updateddata
      }

    ))
  }
  const updateSocialLinks = (network, updates) => {
    // console.log("updateSocialLinks called for network: ", network); // Logs the corresponding network passed correctly
    setSocialLinks((prevSocialLinks) => {
      const existingLink = prevSocialLinks.links.find(link => link.network === network);
      if (existingLink) {
        // Update the existing link
        return {
          ...prevSocialLinks,
          links: prevSocialLinks.links.map((link) =>
            link.network === network ? { ...link, ...updates } : link
          ),
        };
      } else {
        // Add a new link
        return {
          ...prevSocialLinks,
          links: [...prevSocialLinks.links, { network, ...updates }],
        };
      }
    });
  };

  const deleteSocialLink = (network) => {
    setSocialLinks((prevSocialLinks) => ({
      ...prevSocialLinks,
      links: prevSocialLinks.links.filter((link) => link.network !== network),
    }));
  };

  const updateAttachDocs = (file, type) => {
    // console.log("updateAttachDocs called with arguments: ", file, type);
    const fileId = uuidv4(); // Generate a unique identifier for the file
    setAttachDocs(prevFiles => ({
      ...prevFiles,
      [type]: [...prevFiles[type], { ...file, fileId, showQR: false, visible: true }]
    }));
    // console.log("AttachDocs updated: ", AttachDocs);
  };

  const toggleQR = (fileCat, fileId) => {
    setAttachDocs((prevDocs) => ({
      ...prevDocs,
      [fileCat]: prevDocs[fileCat].map((file) =>
        file.fileId === fileId ? { ...file, showQR: !file.showQR } : file
      )
    }));
  };

  const toggleVisibility = (fileCat, fileId) => {
    setAttachDocs((prevDocs) => ({
      ...prevDocs,
      [fileCat]: prevDocs[fileCat].map((file) =>
        file.fileId === fileId ? { ...file, visible: !file.visible } : file
      )
    }));
  };

  const removeAttachDoc = (fileCat, fileId) => {
    setAttachDocs(prevDocs => ({
      ...prevDocs,
      [fileCat]: (prevDocs[fileCat] || []).filter(file => file.fileId !== fileId)
    }));
  };

  // useEffect(() => {
  //   const fetchUserData = async () => {
  //     try {
  //       const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/mail/user`, {
  //         headers: headers
  //       });

  //       // console.log("response ",response);
  //       if (response.status === 200 && response.data) {
  //         const { data } = response;
  //         const {phone_no, email, } = data;

  //         updateContactStyles({mobile_number: phone_no});
  //         updateContactStyles({email: email});
  //       }
  //     } catch (error) {
  //       console.error('Error fetching user data:', error);
  //     }
  //   };

  //   fetchUserData();
  // }, []);


  return (
    // Provide the card details and update function to the children components
    <CreateCardDetailContext.Provider value={{ isPersonalDetailsSaved, setIsPersonalDetailsSaved, cardDetails, setCardDetails, setCardStyles, updateSocialLinks2, updateCardDetails, CardStyles, updateCardStyles, CardQrStyles, updateCardQrStyles, logo, setLogo, ContactStyles, setContactStyles, setSocialLinks, updateContactStyles, setCardQrStyles, SocialLinks, updateSocialLinks, deleteSocialLink, AttachDocs, updateAttachDocs, updateAttachDocsVal, setAttachDocs, toggleQR, toggleVisibility, removeAttachDoc }}>
      {children}
    </CreateCardDetailContext.Provider>
  );
};

// Custom hook to consume the card detail context
export const useCreateCardDetailContext = () => useContext(CreateCardDetailContext);
